import { CircularProgress, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { AppContext } from '../../../AppContext';
import styles from './GenerateButton.styles';
import SketchDrawing from '../SketchDrawing';

const useStyles = makeStyles(styles);

const GenerateButton = ({
  label = 'Generate Sketch',
  title = 'Generate Sketch',
  content = 'You are about to generate a completed sketch as well as valuation information. If you previously made manual changes to the valuation, they may be overwritten. Are you sure you want to continue?',
  onSave,
  layers
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const { dispatch: appDispatch } = useContext(AppContext);
  const [base64, setBase64] = useState(null);
  return (
    <React.Fragment>
      <FormControl fullWidth>
        <Button
          onClick={() => setOpen(!open)}
          style={{ width: '100%' }}
          variant="contained"
          color="default"
          style={{ elevation: 0, borderRadius: 0 }}
        >
          {label}
        </Button>
      </FormControl>
      <Dialog fullWidth maxWidth="lg" open={open} onClose={() => setOpen(!open)}>
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <SketchDrawing layers={layers} defaultWidth={600} defaultHeight={400} onDrawComplete={(base64) => setBase64(base64)} />
          <DialogContentText id="alert-dialog-description">{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {isSaving ? (
            <Typography variant="subtitle1" className={classes.generatingValuesText}>
              {'Generating sketch... '}
              <CircularProgress size={15} className={classes.circularProgress} />
            </Typography>
          ) : (
            <React.Fragment>
              <Button onClick={() => setOpen(false)} color="primary">
                Cancel
              </Button>
              <Button
                onClick={async () => {
                  setIsSaving(true);
                  try {
                    await onSave(base64);
                    setOpen(false);
                    setIsSaving(false);
                    appDispatch({
                      type: 'SET_SNACKBAR',
                      snackbar: { isOpen: true, message: 'Sketch generated successfully.', variant: 'success' },
                    });
                  } catch (error) {
                    setOpen(false);
                    appDispatch({
                      type: 'SET_SNACKBAR',
                      snackbar: { isOpen: true, message: error, variant: 'error' },
                    });
                  }
                }}
                color="primary"
                autoFocus
              >
                Ok
              </Button>
            </React.Fragment>
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
GenerateButton.defaultProps = {};
GenerateButton.propTypes = {
  prop: PropTypes.string,
};

export default GenerateButton;
